module.exports = [{"type":"title","text":"2024-09-29"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: Websocket market data push, added an explanation of the push frequency."},{"type":"html","text":"perpetual future websocket: MAX 240 websocket connections per IP"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-09-23.json
// module id = 6qxj
// module chunks = 3